"use client";

import React, { useState } from 'react';
import { Plus, Minus, MessageCircle, HelpCircle } from 'lucide-react';

const faqData = [
    {
        question: "What is an Automobile Dealer Management System (DMS)?",
        answer: "A DMS is a comprehensive software solution designed to help automotive dealerships manage their entire operations. It integrates sales, inventory, CRM, service, and finance into a single, seamless platform."
    },
    {
        question: "What are the key features of an eMsys DMS?",
        answer: "Our ecosystem includes real-time Inventory Management, advanced CRM for lead tracking, Service Management for work orders, and robust Financial Analytics with GST-ready invoicing."
    },
    {
        question: "How does a DMS improve dealership efficiency?",
        answer: "By automating routine paperwork and manual data entry, a DMS reduces human error by up to 80%. It provides real-time access to data across all departments, ensuring faster decision-making."
    },
    {
        question: "Is data migration from my old system possible?",
        answer: "Yes, we provide robust integration and migration capabilities. Our support team ensures a seamless transition of your historical customer and financial data into the new platform."
    }
];

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <section className="pt-15 md:pt-20 bg-white">
            <div className="container mx-auto px-6 md:px-12 lg:px-24">
                {/* Remove items-center to ensure top alignment */}
                <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-24">

                    {/* Left Side: Adjusted for top alignment */}
                    <div className="w-full lg:w-1/3 lg:sticky lg:top-10 h-fit space-y-8 pt-2">
                        <div className="space-y-4">
                            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand/10 text-brand text-[10px] font-black  tracking-widest">
                                <HelpCircle size={14} />
                                <span>Common Questions</span>
                            </div>
                            <h2 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tighter leading-[0.9] pt-2">
                                Solving Your <br />
                                <span className="text-brand">Queries.</span>
                            </h2>
                            <p className="text-slate-700 font-medium text-lg leading-relaxed">
                                Everything you need to know about our automotive technology ecosystem.
                            </p>
                        </div>

                        {/* Support Card */}
                        <div className="p-8 rounded-[2rem] bg-slate-900 text-white space-y-4 shadow-xl shadow-slate-200">
                            <h4 className="text-xl font-bold">Still have questions?</h4>
                            <p className="text-slate-400 text-sm font-medium">
                                Our support team is ready to help you optimize your dealership.
                            </p>
                            <button className="flex items-center gap-2 text-brand font-black hover:text-white transition-colors group">
                                <MessageCircle size={20} />
                                <span>Contact Support</span>
                                <div className="h-px w-0 group-hover:w-8 bg-brand transition-all duration-300" />
                            </button>
                        </div>
                    </div>

                    {/* Right Side: FAQ List */}
                    <div className="w-full lg:w-2/3">
                        {/* Remove top border from first item to make it sit higher if needed */}
                        <div className="divide-y divide-slate-200 border-t border-slate-200">
                            {faqData.map((item, index) => (
                                <div key={index} className="group">
                                    <button
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                        aria-expanded={openIndex === index}
                                        className="w-full py-7 md:py-9 flex items-start justify-between text-left gap-6"
                                    >
                                        <span className={`text-xl md:text-2xl font-extrabold tracking-tight transition-colors duration-300 ${openIndex === index ? 'text-brand' : 'text-slate-900 group-hover:text-brand/70'
                                            }`}>
                                            {item.question}
                                        </span>
                                        <div className={`mt-1 shrink-0 w-10 h-10 rounded-full flex items-center justify-center border transition-all duration-300 ${openIndex === index
                                            ? 'bg-brand border-brand text-white rotate-180 shadow-lg shadow-brand/20'
                                            : 'border-slate-200 text-slate-400 group-hover:border-brand/30 group-hover:text-brand'
                                            }`}>
                                            {openIndex === index ? <Minus size={20} /> : <Plus size={20} />}
                                        </div>
                                    </button>

                                    <div className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === index ? 'max-h-[500px] opacity-100 mb-8' : 'max-h-0 opacity-0'
                                        }`}>
                                        <div className="pr-12">
                                            <p className="text-slate-700 text-lg leading-relaxed font-medium">
                                                {item.answer}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default FAQ;